import * as THREE from 'three';

export const isHotspotObject = (obj) =>
  !!obj && (obj.userData?.isHotspot === true || obj.deleteType === 'hotspot');

export const isHotspotAssetRecord = (asset) =>
  !!asset &&
  (asset.deleteType === 'hotspot' ||
    asset.type === 'hotspot' ||
    asset.userData?.isHotspot === true);

export const isHotspotInternalChild = (child, hotspotGroup) => {
  if (!child || !hotspotGroup) return false;
  if (child.userData?.nonSelectable || child.userData?.isbutton) return true;

  const hotspotId =
    hotspotGroup.name ||
    hotspotGroup._id ||
    hotspotGroup.userData?.hotspot?.id;

  if (hotspotId && typeof child.name === 'string') {
    return (
      child.name === `${hotspotId}-button` ||
      child.name === `${hotspotId}-message`
    );
  }

  return false;
};

/** Hotspots stay at scene root; nothing can be parented under a hotspot. */
export const canEstablishParentChild = (parentObj, childObj) => {
  if (!parentObj || !childObj) return false;
  if (isHotspotObject(childObj) || isHotspotObject(parentObj)) return false;
  return true;
};

export const detachHotspotToSceneRoot = (scene, hotspotObj) => {
  if (!scene || !isHotspotObject(hotspotObj)) return;
  if (!hotspotObj.parent || hotspotObj.parent === scene) return;

  try {
    scene.attach(hotspotObj);
  } catch {
    const worldPosition = hotspotObj.getWorldPosition(new THREE.Vector3());
    const worldQuaternion = hotspotObj.getWorldQuaternion(
      new THREE.Quaternion()
    );
    const worldScale = hotspotObj.getWorldScale(new THREE.Vector3());
    hotspotObj.parent.remove(hotspotObj);
    scene.add(hotspotObj);
    hotspotObj.position.copy(worldPosition);
    hotspotObj.quaternion.copy(worldQuaternion);
    hotspotObj.scale.copy(worldScale);
    hotspotObj.updateMatrixWorld(true);
  }
};

export const detachExternalChildrenFromHotspot = (scene, hotspotObj) => {
  if (!scene || !isHotspotObject(hotspotObj)) return;

  [...hotspotObj.children].forEach((child) => {
    if (isHotspotInternalChild(child, hotspotObj)) return;

    try {
      scene.attach(child);
    } catch {
      hotspotObj.remove(child);
      scene.add(child);
    }
  });
};

export const enforceHotspotHierarchyRules = (scene) => {
  if (!scene) return;

  const hotspots = [];
  scene.traverse((obj) => {
    if (isHotspotObject(obj)) hotspots.push(obj);
  });

  hotspots.forEach((hotspot) => {
    detachHotspotToSceneRoot(scene, hotspot);
    detachExternalChildrenFromHotspot(scene, hotspot);
  });
};
